import { Button, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import { FormattedMessage } from 'react-intl';

interface SaveBarProps {
  onClickDelete: () => void;
  changeDate?: Date;
}

const SaveBar = (props: SaveBarProps) => {
  const { onClickDelete, changeDate } = props;
  const formik = useFormikContext();
  return (
      <Stack direction={'row-reverse'} spacing={2} padding={2}>
        <Button
          variant="contained"
          disabled={formik.isSubmitting}
          onClick={() => formik.submitForm()}>
          <FormattedMessage id="Save" />
        </Button>
          <Button variant="contained" color="secondary" onClick={() => formik.resetForm()}>
          <FormattedMessage id="Reset" />
        </Button>
        <Button variant="contained" color="secondary" onClick={() => onClickDelete()}>
          <FormattedMessage id="Delete" />
          </Button>
          <Button variant="contained" color="secondary" onClick={() => { window.history.back() }  }>
              <FormattedMessage id="GoBack" />
          </Button>
      </Stack>
  );
};

export default SaveBar;
